import { Injectable, inject } from "@angular/core";

import {
    IApplicationEventTracer,
    LG_APPLICATION_EVENT_TRACER,
} from "@logex/framework/core";
import { LgMatTrackingService } from "@logex/framework/lg-application";
import { IMatomo } from "@mrdm-self-service-frontend/shared/types";

import { MatomoConfiguration } from "./matomo-configuration.service";

const Category = "MrdmSelfService";

@Injectable({
    providedIn: "root",
})
export class SelfServiceEventTracer {
    private _tracer = inject<IApplicationEventTracer>(LG_APPLICATION_EVENT_TRACER);
    private _matomo = inject(LgMatTrackingService);
    private _matomoConfiguration = inject(MatomoConfiguration);


    setOrganization(organization: number): void {
        this._matomoConfiguration.setOrganizationId(organization);
        if (this._matomoConfig?.organizationDimensionId) {
            this._matomo.setCustomDimension(
                this._matomoConfig.organizationDimensionId,
                organization
            );
            this._tracer.trackEvent(
                Category,
                "organization",
                organization.toString()
            );
        }
    }

    setRegistry(registry: string): void {
        if (this._matomoConfig?.registryDimensionId) {
            this._matomo.setCustomDimension(
                this._matomoConfig.registryDimensionId,
                registry
            );
            this._tracer.trackEvent(Category, "registry", registry);
        }
    }

    private get _matomoConfig(): IMatomo | undefined {
        return this._matomoConfiguration?.configuration?.matomo;
    }
}
